import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
//import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import {
	BasicSelect
} from 'vue-search-select'

export default {
	name: 'connectionhub',
	components: {
		BasicSelect,
		Paginate,
		VueElementLoading,
		DatePicker
	},
	props: [],
	data() {
		return {
			useremail: '',
			isLoading: false,
			selectedObjHubName: {
				value: "",
				text: ""
			},
			hubNameOptList: [],
			hubName: '',
			routeMode: '',
			fromToDate: '',
			hubright: '',
			ddloader: '<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
			scheduledConnection: [],
			updateCDObj: {
				routeMode: '',
				coloader: '',
				trainFlight: '',
				reason: ''
			},
			lineHaulDetailsID: '',
			connectionId: '',
			coloaderArrayObj: [],
			isDisplayCDUpdate: false,
			invoiceNo: '',
			trainFlightArrayObj: [],
			trainFlightDt: '',
			loaderCL: '',
			loaderTF: '',
			totalRows:0,
			pageNo: 0,
			limit:10,
			pageCount: 0,
			hubid:'',
			inVoiceNo:''
		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:MM:SS');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail[0].email;
		this.hubid = userdetail[0].HubId[0];
		this.getSourceHubNameList();
	},
	methods: {
		getSourceHubNameList() {
			this.hubright = this.ddloader
			this.hubNameOptList = [];
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				// id: this.hubzoneid
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					var response = result.data
					if (response.ResultCode == 100) {
						for (i = 0; i < response.ResponseData.length; i++) {
							this.hubNameOptList.push({
								value: response.ResponseData[i].HubID,
								text: response.ResponseData[i].HubName + ' (' + response.ResponseData[i].HubID + ')',
								text1: response.ResponseData[i].HubName
							})
							if(response.ResponseData[i].HubID==this.hubid){
								this.selectedObjHubName={
									value:response.ResponseData[i].HubID,
									text:response.ResponseData[i].HubName
								}
							}
						}
						this.hubName = this.selectedObjHubName.value
					}
					this.hubright = ''
				}, error => {
					this.hubright = ''
					console.error(error)
				})
		},
		// selectedHubNameFlt(selectedObjHubName) {
		// 	this.selectedObjHubName = selectedObjHubName
		// 	this.hubName = this.selectedObjHubName.value
		// },
		onSubmitLHCO(scope) {
			this.$validator.validateAll(scope).then((result) => {
				if (result) {
					this.isLoading = true
					this.scheduledConnection = []
					this.isDisplayCDUpdate = false
					var fromDate = ""
					var toDate = ""
					if (this.fromToDate) {
						var fromDate = moment(this.fromToDate[0]).format('YYYY-MM-DD');
						var toDate = moment(this.fromToDate[1]).format('YYYY-MM-DD');
					}
					this.input = ({
						HubID: this.hubName,
						RouteMode: this.routeMode,
						FromDate: fromDate,
						ToDate: toDate
					})
					axios({
							method: 'GET',
							'url': apiUrl.allocateRuleapi_url + 'LineHaulLstForCoLoaderShifting?HubID=' + this.hubName + '&RouteMode=' + this.routeMode + '&FromDate=' + fromDate + '&ToDate=' + toDate+'&limit='+this.limit+'&offset='+this.pageNo+'&InvoiceNo='+this.inVoiceNo,
							// 'data': this.input,
							headers: {
								'Authorization': 'authkey xB84JJ89Hd25'
							}
						})
						.then(result => {
							var response = result.data
							if (result.status == 200 && response.ResultCode == 100) {
								this.totalRows = result.data.TotalCount
								if (this.totalRows < 10) {
									this.pageCount = 1
								} else {
									this.pageCount = Math.ceil(this.totalRows / 10);
								}
								this.scheduledConnection = response.ResultData;
							} else {
								//this.$alertify.error("No record found")
								this.$alert("No record found", "", "error");
							}
							this.isLoading = false
						}, error => {
							this.isLoading = false
							console.error(error)
						})
				} else {
					console.log('errors exist', this.errors)
				}
			});
		},
		getPaginationData(pageNum) {
			this.pageNo = (pageNum - 1)
			this.onSubmitLHCO()
		},
		resetFormCSP() {
			this.totalRows=0
			this.routeMode = ''
			this.fromToDate = ''
			this.scheduledConnection = []
			this.isDisplayCDUpdate = false
			this.$validator.reset();
			this.errors.clear();
			this.inVoiceNo=''
		},
		editScheduledConnection(data) {
			this.updateCDObj.routeMode = ""
			this.connectionId = ""
			this.lineHaulDetailsID = ""
			if (data.routemode == "Surface" || data.routemode == "Air" || data.routemode == "Train") {
				$('html, body').animate({
					scrollTop: $("#UpdateLHCO").offset().top
				}, 1000);
				this.invoiceNo = data.invoiceno
				this.updateCDObj.routeMode = data.routemode
				this.connectionId = data.connectionid
				this.lineHaulDetailsID = data.linehauldetailsid
				this.loadColoaders()
			}
		},
		loadColoaders() {
			this.loaderCL = this.ddloader
			this.coloaderArrayObj = []
			this.updateCDObj.coloader = ""

			this.trainFlightArrayObj = []
			this.updateCDObj.trainFlight = ""

			if (this.connectionId && this.updateCDObj.routeMode) {
				this.input = ({
					connectionid: this.connectionId,
					mode: this.updateCDObj.routeMode
				})
				axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'getcoloadermapping',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
					.then(result => {
						var response = result.data
						if (result.data.ResultCode == 100 && response.count > 0) {
							this.coloaderArrayObj = response.ResponseData;
							this.isDisplayCDUpdate = true
						} else {
							this.isDisplayCDUpdate = true
							//this.$alertify.error("No coloaders found")
							this.$alert("No coloaders found", "", "error");
						}
						this.loaderCL = ''
					}, error => {
						this.loaderCL = ''
						this.isDisplayCDUpdate = true
						console.error(error)
					})
			}
		},
		getTrainFlightDetails(lhId,trainId) {
			$("#displayTFDtl" + lhId +trainId).html(this.ddloader)
			this.input = {
				lhtrainflightdetailsid: lhId
			}
			axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'getlinehaulDetails',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
				.then(result => {
					var response = result.data
					if (response.ResultCode == 100) {
						if (response.ResponseData.length > 0) {
							this.trainFlightDt = response.ResponseData[0].RouteMode == "Surface" ? response.ResponseData[0].ETA + " " + response.ResponseData[0].ETD : response.ResponseData[0].EntityName + " (" + response.ResponseData[0].EntityNumber + ")";
							$("#displayTFDtl" + lhId +trainId).html(this.trainFlightDt)
						}
					} else {
						this.ddloader = "No data found"
						$("#displayTFDtl" + lhId +trainId).html(this.ddloader)
						//this.$alertify.error("No train/flight details found")
						this.$alert("No train/flight details found", "", "error");
					}
				}, error => {
					console.error(error)
				})
		},
		loadTrainFlight() {
			this.updateCDObj.trainFlight = ""
			this.trainFlightArrayObj = []
			if (this.updateCDObj.coloader) {
				this.loaderTF = this.ddloader
				this.input = {
					ColoaderID: this.updateCDObj.coloader,
					ConnectionID: this.connectionId,
					RouteMode: this.updateCDObj.routeMode
				}
				axios({
				 'method': 'POST',
				 'url': apiUrl.api_url_hubops + 'getLHTrainFlightDetails',
				 'data': this.input,
				 'headers': {
					 'authorization': 'authkey xB84JJ89Hd25'
				 }
			 })
					.then(result => {
						var response = result.data
						if (response.ResultCode == 100) {
							this.trainFlightArrayObj = response.ResponseData;
						} else {
							//this.$alertify.error("No train/flight details found")
							this.$alert("No train/flight details found", "", "error");
						}
						this.loaderTF = ''
					}, error => {
						this.loaderTF = ''
						console.error(error)
					})
			}
		},
		onSubmitUpdateLHCO(scope) {
			this.$validator.validateAll(scope).then((result) => {
				if (result) {
					var self = this
					var tmp = self.coloaderArrayObj.filter(obj => obj.ColoaderID == self.updateCDObj.coloader)
					var cname = tmp.length > 0 ? tmp[0].ColoaderName : ''
					this.input = {
						LineHaulDetailsID: this.lineHaulDetailsID,
						RouteMode: this.updateCDObj.routeMode,
						ColoaderId: this.updateCDObj.coloader,
						ColoaderName: cname,
						LHTrainFlightDetailsId: this.updateCDObj.trainFlight,
						Reason: this.updateCDObj.reason,
						LastModifiedBy: this.useremail
					}
					axios({
							method: 'POST',
							'url': apiUrl.allocateRuleapi_url + 'UpdateCoLoaderScheduledConnection',
							'data': this.input,
							headers: {
								'Authorization': 'authkey xB84JJ89Hd25'
							}
						})
						.then(result => {
							var response = result.data
							if (result.status == 200 && response.ResultCode == 100) {
								//this.$alertify.success("Coloader details update Successfully.")
								this.$alert("Coloader details update Successfully.", "", "success");
								this.cancelFormCDUP();
							} else if (response.ResultCode == 101 || response.ResultCode == 500) {
								//this.$alertify.error(response.ReturnMessage)
								this.$alert(response.ReturnMessage, "", "error");
							} else {
								//this.$alertify.error("Coloader details does not updated, Try again.")
								this.$alert("Coloader details does not updated, Try again.", "", "error");
							}
						}, error => {
							console.error(error)
						})
				} else {
					console.log('errors exist', this.errors)
				}
			})
		},
		cancelFormCDUP() {
			for (var eachObj in this.updateCDObj) {
				this.updateCDObj[eachObj] = ""
			}
			this.$validator.reset();
			this.errors.clear();
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/ShiftConnectionLHCO/ShiftConnectionLHCO.component.js